// extracted by mini-css-extract-plugin
export default {"label":"entranceScreen_label__H0zD3"};